module.exports = __webpack_public_path__ + "img/data3-2.5e174d8b.png";